import React from 'react';
import { Box, Typography, Stack, Switch } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { OrganizationPerformanceReportingConfig } from '../../../_types/performanceReporting';
import datetimeHelper from 'helpers/datetimeHelper';

interface ViewProps {
  config: OrganizationPerformanceReportingConfig;
}

const View: React.FC<ViewProps> = ({ config }) => {
  return (
    <Box sx={{ gap: 6, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography
          variant='subtitleSm'
          sx={{ mb: 1 }}
        >
          {t('manageSolutions.performanceReporting.globalExpiration')}
        </Typography>
        <Typography
          variant='bodySm'
          sx={{ pl: 3 }}
        >
          {datetimeHelper.formatDate(config.globalExpiresAt, { missingDisplay: '--' })}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography
          variant='subtitleSm'
          sx={{ mb: 1 }}
        >
          {t('manageSolutions.performanceReporting.activeSubscriptions')}
        </Typography>
        <Stack spacing={2}>
          {config.modules.map((module) => {
            const isEnabled = module.status === 'ENABLED';
            return (
              <Box
                key={module.id}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                }}
              >
                <Switch
                  checked={isEnabled}
                  disabled
                  color='success'
                  size='xs'
                />
                <Typography
                  variant='bodySm'
                  sx={{ flex: 1 }}
                >
                  {module.name}
                </Typography>
                <Typography
                  variant='bodySm'
                  sx={{ minWidth: 180, textAlign: 'right' }}
                >
                  {datetimeHelper.formatDate(module.expiresAt, { missingDisplay: '--' })}
                </Typography>
              </Box>
            );
          })}
        </Stack>
      </Box>
    </Box>
  );
};

export default View;
